import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PayehaComponent } from './payehaComponent/payeha.component';
import { APICard_List_Component } from './apicard/apicard-list/apicard-list.component';



const routes: Routes = [
  // {path: '', redirectTo: '/main', pathMatch: 'full' },
  // {path: 'main', component: PayehaComponent },
  {path: '', component: PayehaComponent },
  // {path: '/apilist', component: APICard_List_Component},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
